import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import Reveal, { fadeUp, stagger } from "./Reveal";

export default function Testimonials() {
  const { content, t } = useSite();
  const s = content?.testimonials_section;
  const items = content?.testimonials || [];
  if (!items.length) return null;

  return (
    <section id="reviews" className="py-24 sm:py-28 bg-brand-ink/50 border-y border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="mb-14">
          <div className="flex items-center gap-3 mb-4">
            <span className="stitch-x w-10 text-brand-orange" />
            <span className="font-mono2 text-xs uppercase tracking-[0.3em] text-brand-orange">{t(s?.eyebrow)}</span>
          </div>
          <h2 className="font-display uppercase text-4xl sm:text-5xl leading-[1.02] max-w-2xl">{t(s?.title)}</h2>
        </Reveal>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          className="grid md:grid-cols-3 gap-6"
        >
          {items.map((r, i) => (
            <motion.blockquote
              key={i}
              variants={fadeUp}
              data-testid={`testimonial-${i}`}
              className="lift rounded-xl border border-white/10 bg-brand-navy p-8 flex flex-col"
            >
              <Quote size={30} className="text-brand-blue mb-5 rotate-180" />
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, j) => (
                  <Star key={j} size={14} className="fill-brand-orange text-brand-orange" />
                ))}
              </div>
              <p className="text-white/85 leading-relaxed flex-1">"{t(r.text)}"</p>
              <footer className="mt-6 pt-4 border-t border-dashed border-white/15 font-mono2 text-sm font-semibold text-brand-orange">
                {r.name}
              </footer>
            </motion.blockquote>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
